import {
    Box,
    Button,
    FormControl,
    FormLabel,
    HStack,
    Select,
    Stack,
    Table,
    Tag,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from "@chakra-ui/react";
import { addDays, format } from "date-fns";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { MdFileDownload } from "react-icons/md";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Optional } from "../../components/Form";
import { LoadMore } from "../../components/LoadMore";
import Search from "../../components/Search";
import { Title } from "../../components/Title";
import {
    AccountSubscription,
    InsurancePolicyHolderSubscriptionAuthorization,
    ParticipantRole,
    SubscriptionAuthorizationStatus,
    useSubscriptions2CsvMutation,
    useTiersQuery
} from "../../graphql";
import { useAccountSubscriptions, useAllCalls } from "../../hooks";
import { formatDate, formatDateTime, getFullName } from "../../utils";



import { getSubscriptionMethod } from "../Subscription/subscription";

export const SubscriptionsFilter = ({ onChange }) => {
    const { data: tierData, loading: loadingTiers } = useTiersQuery();
    const [startRange, setStartRange] = useState(true);
    const now = new Date();
    const [generatingCSV, setGenerateCSV] = useState(false);
    const last30days = addDays(now, -30);

    const [startDateFrom, setStartDateFrom] = useState(last30days);
    const [startDateTo, setStartDateTo] = useState(now);

    const [endDateFrom, setEndDateFrom] = useState(last30days);
    const [endDateTo, setEndDateTo] = useState(now);

    const [generateCSV] = useSubscriptions2CsvMutation();

    const DateInput = ({ value, onClick }) => (
        <Button size="sm" onClick={ onClick }>
            { value }
        </Button>
    );

    const onDownload = async (query) => {
        setGenerateCSV(true);

        const { data } = await generateCSV({
            variables: {
                range: query.startDateFrom
                    ? {
                        from: query.startDateFrom
                            ? format(query.startDateFrom, "yyyy-MM-dd")
                            : null,
                        to: query.startDateTo
                            ? format(addDays(query.startDateTo, 1), "yyyy-MM-dd")
                            : null
                    }
                    : null,
                endRange: query.startDateFrom
                    ? {
                        from: query.startDateFrom
                            ? format(query.startDateFrom, "yyyy-MM-dd")
                            : null,
                        to: query.startDateTo
                            ? format(addDays(query.startDateTo, 1), "yyyy-MM-dd")
                            : null
                    }
                    : null
            }
        });

        const url = data.subscriptions2csv;

        setGenerateCSV(false);

        let a = document.createElement("a");
        a.href = url;
        a.download = url.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <HStack spacing={ 3 }>
            <Stack>
                <Text
                    onClick={ () => setStartRange(true) }
                    fontSize="xs"
                    p={ 0 }
                    m={ 0 }
                    lineHeight={ 0.2 }
                >
                    Paketa
                </Text>
                <FormControl>
                    <Select
                        size="sm"
                        disabled={ loadingTiers }
                        onChange={ (event) =>
                            onChange({ tierId: parseInt(event.target.value) })
                        }
                    >
                        <option value="-1">Të gjitha</option>
                        { tierData?.tiers?.map((t) => {
                            return (
                                <option key={ t.id } value={ t.id }>
                                    { t.name }
                                </option>
                            );
                        }) }
                    </Select>
                </FormControl>
            </Stack>
            <Stack>
                <HStack>
                    <Text
                        onClick={ () => setStartRange(true) }
                        fontSize="xs"
                        p={ 0 }
                        m={ 0 }
                        lineHeight={ 0.2 }
                        style={
                            startRange
                                ? {
                                    color: "#205aa7",
                                    fontWeight: "bold",
                                    cursor: "pointer,"
                                }
                                : {
                                    cursor: "pointer,"
                        }
                        }
                    >
                        Fillimi
                    </Text>
                    <Text
                        onClick={ () => setStartRange(false) }
                        fontSize="xs"
                        p={ 0 }
                        m={ 0 }
                        lineHeight={ 0.2 }
                        style={
                            !startRange
                                ? {
                                    color: "#205aa7",
                                    fontWeight: "bold",
                                    cursor: "pointer,"
                                }
                                : {
                                    cursor: "pointer,"
                        }
                        }
                    >
                        Përfundimi
                    </Text>
                    <Text fontSize="xs" p={ 0 } m={ 0 } lineHeight={ 0.2 }>
                        (periudhë)
                    </Text>
                </HStack>

                { startRange && (
                    <div>
                        <HStack>
                            <DatePicker
                                selected={ startDateFrom }
                                onChange={ (date) => {
                                    if (date) {
                                        setStartDateFrom(date);
                                        onChange({
                                            startDateFrom: date,
                                            startDateTo
                                        });
                                    }
                                } }
                                selectsStart
                                startDate={ startDateFrom }
                                endDate={ startDateTo }
                                // @ts-ignore
                                customInput={ <DateInput /> }
                            />

                            <DatePicker
                                selected={ startDateTo }
                                onChange={ (date) => {
                                    if (date) {
                                        setStartDateTo(date);
                                        onChange({
                                            startDateFrom,
                                            startDateTo: date
                                        });
                                    }
                                } }
                                selectsEnd
                                startDate={ startDateFrom }
                                endDate={ startDateTo }
                                minDate={ startDateFrom }
                                // @ts-ignore
                                customInput={ <DateInput /> }
                            />
                        </HStack>
                    </div>
                ) }
                { !startRange && (
                    <div>
                        <HStack>
                            <DatePicker
                                selected={ endDateFrom }
                                onChange={ (date) => {
                                    if (date) {
                                        setEndDateFrom(date);
                                        onChange({
                                            endDateFrom: date,
                                            endDateTo
                                        });
                                    }
                                } }
                                selectsStart
                                startDate={ endDateFrom }
                                endDate={ endDateTo }
                                // @ts-ignore
                                customInput={ <DateInput /> }
                            />

                            <DatePicker
                                selected={ endDateTo }
                                onChange={ (date) => {
                                    if (date) {
                                        setEndDateTo(date);
                                        onChange({
                                            endDateFrom,
                                            endDateTo: date
                                        });
                                    }
                                } }
                                selectsEnd
                                startDate={ endDateFrom }
                                endDate={ endDateTo }
                                minDate={ endDateFrom }
                                // @ts-ignore
                                customInput={ <DateInput /> }
                            />
                        </HStack>
                    </div>
                ) }
            </Stack>

            <Stack>
                <Text fontSize="xs" p={ 0 } m={ 0 } lineHeight={ 0.2 }>
                    Dokument CSV
                </Text>
                <Button
                    rightIcon={ <MdFileDownload /> }
                    colorScheme="blue"
                    size="sm"
                    variant="ghost"
                    width="100px"
                    isLoading={ generatingCSV }
                    onClick={ () => {
                        onDownload({
                            startDateFrom,
                            startDateTo
                        });
                    } }
                >
                    Shkarko
                </Button>
            </Stack>
        </HStack>
    );
};

export const getSubscriptionStatus = (item: Optional<AccountSubscription>) => {
    if (
        item.authorization.__typename ===
    "InsurancePolicyHolderSubscriptionAuthorization"
    ) {
        const authorizationStatus = (item.authorization as InsurancePolicyHolderSubscriptionAuthorization)
            .status;

        if (
            authorizationStatus ===
      SubscriptionAuthorizationStatus.RequiredVerification
        ) {
            return <Tag colorScheme="orange">Kërkon verifikim</Tag>;
        }
    }
    // (item as InsurancePolicyHolderSubscriptionAuthorization)
    return item.isActive ? "Aktive" : "Jo aktive";
};

export const Subscriptions: React.FC = () => {
    const {
        loading,
        items,
        loadMore,
        hasNextPage,
        totalCount,
        refresh
    } = useAccountSubscriptions();

    return (
        <>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title="Lista e abonimeve">
                    <SubscriptionsFilter
                        onChange={ (data) => {
                            refresh({
                                from: data.startDateFrom,
                                to: data.startDateTo,
                                endFrom: data.endDateFrom,
                                endTo: data.endDateTo,
                                tierId: data.tierId
                            });
                        } }
                    />
                </Title>

                <Table variant="striped" size="sm" marginTop="15px">
                    <Thead>
                        <Tr>
                            <Th>Klienti</Th>
                            <Th>Paketa</Th>
                            <Th>Fillimi</Th>
                            <Th>Përfundimi</Th>
                            <Th>Statusi</Th>
                            <Th>Metoda</Th>
                            { /* <Th>Telefonuesi</Th>
              <Th>Të ftuar</Th>
              <Th>Statusi</Th>
              <Th>Data</Th>
              <Th>Kohëzgjatja</Th> */ }
                        </Tr>
                    </Thead>
                    <Tbody>
                        { items?.map((item) => {
                            // const participants = call.participants;

                            return (
                                <Tr key={ item.id }>
                                    <Td>
                                        <Link to={ `/subscription/${item.id}` }>
                                            { item?.account ? (
                                                <AccountAvatar
                                                    key={ item?.account?.id }
                                                    account={ item?.account }
                                                    size="xs"
                                                    role={ false }
                                                />
                                            ) : null }
                                        </Link>
                                    </Td>
                                    <Td>{ item.tier.name }</Td>
                                    <Td>{ formatDate(item.startDate) }</Td>
                                    <Td>{ formatDate(item.expirationDate) }</Td>
                                    <Td>{ getSubscriptionStatus(item) }</Td>
                                    <Td>{ getSubscriptionMethod(item.authorization) }</Td>
                                </Tr>
                            );
                        }) }
                    </Tbody>
                </Table>

                <LoadMore hasNextPage={ hasNextPage } loadMore={ loadMore } />
            </Box>
        </>
    );
};
